import type { Range } from "../lib/types";

interface Props {
  value: Range;
  onChange: (next: Range) => void;
}

const OPTIONS: Range[] = [30, 60, 90];

export function RangeToggle({ value, onChange }: Props) {
  return (
    <div
      role="group"
      aria-label="Time range"
      style={{ display: "inline-flex", gap: 2 }}
    >
      {OPTIONS.map((opt) => {
        const active = value === opt;
        return (
          <button
            key={opt}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(opt)}
            style={{
              minHeight: 44,
              padding: "0 12px",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
              background: active ? "rgba(255,255,255,0.12)" : "rgba(255,255,255,0.04)",
              color: active ? "var(--color-bone)" : "var(--color-bone-dim)",
              fontFamily: "var(--font-mono)",
              fontSize: "var(--fs-xs)",
              letterSpacing: "var(--letter-label)",
              textTransform: "uppercase",
              fontWeight: 600,
              transition: "background 0.15s, color 0.15s",
            }}
          >
            {opt}d
          </button>
        );
      })}
    </div>
  );
}
